import {mapActions, mapGetters, mapState} from "vuex";
import {UserRole} from "@/api/api.client";
export default {
    methods: {
        ...mapActions(['MODAL', 'IS_GLOBAL_LOADING']),
        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        },
        getS3Key(s3Key) {
            if (!s3Key) return null;
            let cloudUrl = process.env.VUE_APP_BUILD_ENV
            if (cloudUrl) {
                return `${cloudUrl}/${s3Key}`
            }
            return null
        },
        focusTrue() {
                this.focusParam = true;
        },
        focusFalse() {
            this.focusParam = false;
        },

        setInputToItemFromItems(value, key, itemId) {
            let findItem = this.items.find(item => item.id === itemId)
            if(findItem) {
                findItem[key] = value
            }
        },
        setInputInfo(value, key, values) {
            if (values?.hasOwnProperty(key)) {
                values[key] = value;
            }
        },
        activateAlert() {
            clearTimeout(this.timerAlert)
            this.activeAlert = true;
            this.timerAlert = setTimeout(() => {
                this.activeAlert = false
            }, 1500)
        },
        isNullObj(item) {
            return item === '' || item === undefined || item === null
        },
        deepEqual(obj1, obj2) {
            if (obj1 === obj2) {
                return true;
            }
            if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
                return false;
            }
            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);
            if (keys1.length !== keys2.length) {
                return false;
            }

            for (let key of keys1) {
                if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) {
                    return false;
                }
            }
            return true;
        },

        getS3Url(s3Key) {
            if (!s3Key) return null;
            let cloudfrontBaseUrl = process.env.VUE_APP_BUILD_ENV
            if (cloudfrontBaseUrl) {
                return `${cloudfrontBaseUrl}/${s3Key}`;
            }
            return null;
        }
    },
    computed: {
        ...mapGetters(['isActiveModalName']),
        ...mapState(['$isMobile']),
        ...mapState('tags', ['tags']),
        query() {
            return this.$route.query;
        },
        queryLog() {
            return this.query?.log;
        },
        activeModalInfo() {
            return this.isActiveModalName?.info
        },

        userRoleComputed() {
            return [
                {
                    label: 'Главный администратор',
                    value:  UserRole.OWNER
                },
                {
                    label: 'Администратор',
                    value:  UserRole.ADMIN
                },
                {
                    label: 'Сотрудник',
                    value:  UserRole.EMPLOYEE
                }
            ]
        }

    }
}